import { createRouter, createWebHistory } from 'vue-router'

const history = createWebHistory()

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/Home.vue')
    },
    {
        path: '/app',
        name: 'app',
        component: () => import('../views/AppList.vue')
    },
]

const router = new createRouter({
    history,
    routes
})

export default router